// extracted by mini-css-extract-plugin
module.exports = {"toast":"toast_toast__3h0At","danger":"toast_danger__80lcm","success":"toast_success__3XKWL"};